// extracted by mini-css-extract-plugin
module.exports = {"heading":"accordion_heading__2jMoa","element":"accordion_element__1L8a8","subheading":"accordion_subheading__3CLOh","children":"accordion_children__1Kcjn"};